const {
  makeInternal,
  queryString,
  navigate
} = svs.utils.url;
const RedirectToReturnUrl = () => {
  navigate(makeInternal(queryString.returnUrl, '/'));
  return null;
};
export default RedirectToReturnUrl;